<template>
  <button
    :class="{
      'control__btn--favorite': doc.is_favorite,
    }"
    class="control__btn favorite-btn"
    title="Add to favorites"
    :disabled="view.buttonDisabled"
    @click="favoriteToggle($event)"
  >
    <div class="control__icon-box">
      <span class="control__icon iconfont icontrol-favorite"></span>
      <span
        class="control__icon control__icon--active control__icon--favorite iconfont ifavorite"
      ></span>
    </div>
    <transition name="fade">
      <div v-show="showAdded" class="control-favorite control-favorite-add">
        <div class="control-favorite__flex-box">
          <span class="control-favorite__icon iconfont ifavorite"></span>Adding
          to Favorites
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div
        v-show="showRemoved"
        class="control-favorite control-favorite-remove"
      >
        <div class="control-favorite__flex-box">
          <span class="control-favorite__icon iconfont icontrol-favorite"></span
          >Removing from Favorites
        </div>
      </div>
    </transition>
  </button>
</template>

<script setup lang="ts">
import { computed, onBeforeMount, ref, watch } from 'vue'

import { DocView } from '@/models/doc'
import { DocFavoriteView } from '@/models/doc.favorite'
import { assertNotNull } from '@/helpers/typing'

const props = defineProps<{
  doc: DocView
}>()

const view = ref<DocFavoriteView | null>(null)

onBeforeMount(() => {
  view.value = new DocFavoriteView(props.doc)
})

watch(
  () => props.doc,
  (newValue) => {
    view.value = new DocFavoriteView(newValue)
  },
  { deep: false },
)

async function favoriteToggle($event: Event): Promise<void> {
  await assertNotNull(view.value).favoriteToggle($event)
}

const showAdded = computed(() => {
  return assertNotNull(view.value).hint === 'adding'
})

const showRemoved = computed(() => {
  return assertNotNull(view.value).hint === 'removing'
})
</script>
